import Icon from './components/Icon';
import Svg from './svg/session-completed.svg';
export default props => <Icon component={Svg} data-name="CompletedIcon" {...props} />;